<template>
  <section class="h-8 px-5 bg-dash-black -mt-2">
    <!-- projects slider section -->
    <VueSlickCarousel v-bind="settings" class="">
      <span v-for="(data, i) in marqueeData" :key="i" class="mx-4 text-xs">
        <span class="text-white">{{ data.name }}</span>
        <span :class="data.status == 0 ? 'text-red-700' : 'text-green-600'">
          <i class="fa fa-caret-right"></i> {{ data.amount }}</span
        >
      </span>
    </VueSlickCarousel>
  </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { mapGetters } from "vuex";
export default {
  name: "Footer",
  components: {
    VueSlickCarousel,
  },
  computed: {
    ...mapGetters(["marqueeData"]),
  },
  data() {
    return {
      settings: {
        dots: false,
        arrows: false,
        infinite: true,
        centerMode: false,
        centerPadding: "20px",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 5000,
        autoplaySpeed: 500,
        cssEase: "linear",
      },
    };
  },
};
</script>
